var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.843,
    height: 25.191,
    viewBox: "0 0 24.843 25.191",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "editar-texto",
    d: "M28.343,3.158A3.231,3.231,0,0,0,22.826.871L7.673,16.024a.787.787,0,0,0-.206.362L6.208,21.315a.787.787,0,0,0,1,.946l4.719-1.468a.788.788,0,0,0,.323-.2L27.4,5.445a3.211,3.211,0,0,0,.944-2.287ZM11.27,19.347l-3.189.992.856-3.355L22.2,3.724l2.347,2.347ZM26.286,4.332l-.627.627L23.312,2.611l.627-.627a1.66,1.66,0,1,1,2.347,2.347ZM20.515,25.114H4.287a.787.787,0,1,1,0-1.574H20.515a.787.787,0,1,1,0,1.574Z",
    transform: "translate(-3.5 0.077)",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.df459785.svg";
export { ForwardRef as ReactComponent };